module.exports = __webpack_public_path__ + "media/categories/1018-af72b825.svg";